<script lang="ts">
    export let fill:string = "none";
    export let x: string = "0";
    export let y: string = "0";
    export let width: string = "23";
    export let height: string = "33";
</script>

<svg {x} {y} {width} {height} {fill} viewBox="0 0 23 33" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.7518 13.7916H21.6633L5.71531 30.7565L9.99527 18.6622L10.2312 17.9954H9.52392H1.16809L16.5878 1.83344L13.272 13.1511L13.0843 13.7916H13.7518Z"/>
</svg>
